import type { FC } from "react";
import { useProductMetadata } from "../../../hooks/useProductMetadata";
import { ContainerStackComponentModal } from "./ContainerStackComponentModal";
import { OpenStackInfraComponentModal } from "./OpenStackInfraComponentModal";
import { StandaloneComponentModal } from "./StandaloneComponentModal";

interface ComponentCreateModalProps {
	isVisible: boolean;
	handleCreateModal: (isVisible: boolean) => void;
	hideValidatedComponents?: boolean;
}

enum ComponentType {
	CONTAINER_STACK = "container stack",
	TRADITIONAL_APPLICATION = "traditional application",
	OPENSTACK_INFRASTRUCTURE = "openstack infrastructure",
}

export const ComponentCreateModal: FC<ComponentCreateModalProps> = (props: ComponentCreateModalProps) => {
	const { productDetail } = useProductMetadata();
	const renderComponentCreateModal = () => {
		const productType = productDetail.type;
		if (productType === ComponentType.CONTAINER_STACK) {
			return (
				<ContainerStackComponentModal
					handleCreateModal={props.handleCreateModal}
					{...(props?.hideValidatedComponents !== undefined
						? { hideValidatedComponents: props.hideValidatedComponents }
						: {})}
				/>
			);
		} else if (productType === ComponentType.OPENSTACK_INFRASTRUCTURE) {
			return <OpenStackInfraComponentModal handleCreateModal={props.handleCreateModal} />;
		} else if (productType === ComponentType.TRADITIONAL_APPLICATION) {
			return (
				<StandaloneComponentModal
					handleCreateModal={props.handleCreateModal}
					{...(props?.hideValidatedComponents !== undefined
						? { hideValidatedComponents: props.hideValidatedComponents }
						: {})}
				/>
			);
		}
	};
	return <>{props.isVisible && renderComponentCreateModal()}</>;
};
